
import { Incident } from '../types';

const INCIDENT_CACHE_KEY = 'FOP_INCIDENT_CACHE';
const CACHE_TIMESTAMP_KEY = 'FOP_CACHE_TIMESTAMP';

/**
 * Saves the latest list of incidents to the local database (localStorage).
 * @param incidents The array of incidents to save.
 */
export function saveIncidents(incidents: Incident[]): void {
  try {
    const incidentsJson = JSON.stringify(incidents);
    localStorage.setItem(INCIDENT_CACHE_KEY, incidentsJson);
    localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    console.error("Failed to save incidents to local database:", error);
  }
}

/**
 * Loads incidents from the local database.
 * Returns an empty array if the cache is empty or corrupted.
 * @returns An array of Incident objects.
 */
export function loadIncidents(): Incident[] {
  try {
    const incidentsJson = localStorage.getItem(INCIDENT_CACHE_KEY);
    if (!incidentsJson) {
      return [];
    }
    const incidents = JSON.parse(incidentsJson) as Incident[];
    // Basic validation to ensure it's an array
    return Array.isArray(incidents) ? incidents : [];
  } catch (error) {
    console.error("Failed to load incidents from local database:", error);
    // Clear corrupted cache
    localStorage.removeItem(INCIDENT_CACHE_KEY);
    localStorage.removeItem(CACHE_TIMESTAMP_KEY);
    return [];
  }
}
